<template>
  <section>Offers</section>
</template>

<script>
// import { mapGetters } from 'vuex';
export default {
  computed: {
    // ...mapGetters('rfps', ['selectedRfpId']),
  },
};
</script>
